// src/components/Header.js
import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import BrandLogo from "../BrandLogo";
import GuruPeethLogo from "../GuruPeethLogo";
import { LanguageContext } from "../../context/LanguageContext";
import { IconButton, Tooltip } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import LanguageIcon from "@mui/icons-material/Language";
import "./Header.css";

// Translations remain the same...
const translations = {
  mr: {
    "nav-home": "मुख्यपृष्ठ", "nav-about": "आमच्याबद्दल", "nav-mission": "ध्येय", "nav-activities": "इव्हेंट्स", "nav-vibhag": "१८ विभाग व उपक्रम", "nav-wisdom": "ज्ञान", "nav-datta-dham": "सेवामार्ग दत्त धाम", "nav-contact": "संपर्क", "nav-donate": "देणगी",
  },
  en: {
    "nav-home": "Home", "nav-about": "About", "nav-mission": "Mission & Vision", "nav-activities": "Events", "nav-vibhag": "18 Vibhag & Activities", "nav-wisdom": "Wisdom", "nav-datta-dham": "Seva Marg Datta Dham", "nav-contact": "Contact", "nav-donate": "Donate",
  },
};

const Header = () => {
  const { lang, setLang } = useContext(LanguageContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const t = (key) => translations[lang][key] || translations["en"][key];

  const handleScrollNavigation = (sectionId) => {
    const scrollToSection = () => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    };
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scrollToSection, 400);
    } else {
      scrollToSection();
    }
    setIsMenuOpen(false);
  };

  const toggleLanguage = () => {
    const newLang = lang === "en" ? "mr" : "en";
    setLang(newLang);
    localStorage.setItem("app-lang", newLang);
  };

  const handleMobileLanguageToggle = () => {
    toggleLanguage();
    setIsMenuOpen(false);
  };

  return (
    <header>
      <div className="wrap nav">
        <div className="logo-container">
          <Link to="/" onClick={() => setIsMenuOpen(false)}>
            <BrandLogo />
          </Link>
        </div>

        <nav className={`main-nav ${isMenuOpen ? "open" : ""}`}>
          <ul>
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>{t("nav-home")}</Link></li>
            <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>{t("nav-about")}</Link></li>
            <li><Link to="/vibhag" onClick={() => setIsMenuOpen(false)}>{t("nav-vibhag")}</Link></li>
            <li><a href="#mission" className="nav-scroll-link" onClick={(e) => { e.preventDefault(); handleScrollNavigation("mission"); }}>{t("nav-mission")}</a></li>
            <li><a href="#events" className="nav-scroll-link" onClick={(e) => { e.preventDefault(); handleScrollNavigation("events"); }}>{t("nav-activities")}</a></li>
            <li><Link to="/datt-dham" onClick={() => setIsMenuOpen(false)}>{t("nav-datta-dham")}</Link></li>
            <li className="desktop-only"><Link to="/contact" onClick={() => setIsMenuOpen(false)}>{t("nav-contact")}</Link></li>
            <li className="mobile-only"><Link to="/contact" onClick={() => setIsMenuOpen(false)}>{t("nav-contact")}</Link></li>
            <li className="mobile-only"><Link to="/donation" onClick={() => setIsMenuOpen(false)}>{t("nav-donate")}</Link></li>
            <li className="mobile-only mobile-lang-item">
              <div className="mobile-lang-switcher" onClick={handleMobileLanguageToggle} role="button" tabIndex={0} onKeyPress={(e) => { if (e.key === 'Enter' || e.key === ' ') { handleMobileLanguageToggle(); } }}>
                <Tooltip title={lang === "en" ? "Switch to Marathi" : "Switch to English"}>
                  <IconButton color="primary" size="medium" onClick={(e) => { e.stopPropagation(); handleMobileLanguageToggle(); }}>
                    {lang === "en" ? <TranslateIcon /> : <LanguageIcon />}
                  </IconButton>
                </Tooltip>
                <span className="lang-text">{lang === "en" ? "Switch to Marathi" : "Switch to English"}</span>
              </div>
            </li>
          </ul>
        </nav>

        <div className="actions-container">
          <Link className="cta-donate desktop-only" to="/donation">{t("nav-donate")}</Link>

          <Tooltip title={lang === "en" ? "Switch to Marathi" : "Switch to English"} className="desktop-only">
            <IconButton onClick={toggleLanguage} color="primary" size="large" className="desktop-only">
              {lang === "en" ? <TranslateIcon /> : <LanguageIcon />}
            </IconButton>
          </Tooltip>
          
          {/* ✅ FIX: GuruPeethLogo is now here, and will be visible on desktop. We use CSS to adjust its size for mobile vs desktop. */}
          <Link to="/login" className="gurupeeth-logo-link" onClick={() => setIsMenuOpen(false)}>
            <GuruPeethLogo /> {/* Removed variant, we'll control with CSS */}
          </Link>
          
          <button className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle Menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;